module.exports = {
          srcSet: __webpack_public_path__ + "307a4b1580feeb45ed3bdbcb3da0af1a-1166.png"+" 1166w",
          images:[ {path: __webpack_public_path__ + "307a4b1580feeb45ed3bdbcb3da0af1a-1166.png",width: 1166,height: 489}],
          src: __webpack_public_path__ + "307a4b1580feeb45ed3bdbcb3da0af1a-1166.png",
          toString:function(){return __webpack_public_path__ + "307a4b1580feeb45ed3bdbcb3da0af1a-1166.png"},
          
          width: 1166,
          height: 489
        }